import { useNavigate } from "react-router-dom";
import { orgHomePath } from "@shared/appUrls";

import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

/** Replaces the current URL with the selected organization's home; nothing when none is selected. */
export default function GoToSelectedOrgButton() {
  const { selectedOrganization } = useAuth();
  const navigate = useNavigate();

  if (!selectedOrganization?.id) {
    return null;
  }
  return (
    <Button onClick={() => navigate(orgHomePath(selectedOrganization.id), { replace: true })}>
      Go to {selectedOrganization.name || "your organization"}
    </Button>
  );
}
